'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//全局请求路径
var AXIOS_DEFAULT_CONFIG = exports.AXIOS_DEFAULT_CONFIG = {
  baseURL: '../',
  timeout: 20000
  //sentry配置id
};var sentry = exports.sentry = 'https://b737ed169d6843ec8eea412852203e09@sentry.io/1226863';
//代理前缀
var prefixPath = exports.prefixPath = process.env.NODE_ENV !== 'production' ? 'api/' : '../';
//全局主色调
var mainColor = exports.mainColor = '#1890FF';
//登录成功跳转路由地址
var indexRouter = exports.indexRouter = '/';
//课程配置
var courseConfig = exports.courseConfig = {
  showEval: true, //是否显示评价
  score: {
    title: '课程学时',
    'titleKey': 'course.courseHours',
    prop: 'courseLearningHour',
    transfer: function transfer(v) {
      return v;
    }
  }
};
var power = exports.power = true;